<template>
    <div class="detail-top">
        <el-alert
                :class="{'show': showAlert && !isFinish}"
                title="当前诊断页面数量较多，请耐心等待结果。"
                type="warning" center>
        </el-alert>
        <!--头部咨询条-->
        <div role="alert" class="el-alert el-alert--warning is-center advisory" :class="{'show': showAdvisory && isFinish}">
            <div class="el-alert__content">
                <span class="el-alert__title">
                    想要更精确的人工诊断？每天仅限10个免费名额，
                    <a class="color-f1" href="javascript:;" v-bd-track-event="['营销力诊断', '点击点我咨询']" target="_blank" @click="openCustomer()">点我咨询</a>
                </span>
                <i class="el-alert__closebtn el-icon-close" @click="showAdvisory = false"></i>
            </div>
        </div>
        <div class="detail-progress">
            <div class="lineBlock detail-p-1">
                <score :score="progressData.score" :isFinish="isFinish"></score>
            </div>
            <div class="lineBlock detail-p-2" :class="{'finish': isFinish}">
                <p class="title textEllipsis">{{getTitle()}}</p>
                <p class="subtitle textEllipsis" v-html="progressData.subTitle"></p>
                <grade :score="progressData.score"></grade>
            </div>
            <div class="lineBlock detail-p-3" v-show="!isFinish">
                <el-button
                        class="button-cancel"
                        @click="cancelCheck()">取消诊断
                </el-button>
            </div>
            <div class="lineBlock detail-p-4" v-show="isFinish">
                <el-button type="text" class="btn-back" @click="recheck()">[返回]</el-button>
                <el-button class="btn-recheck" @click="setPKVisible(true)" v-bd-track-event="['营销力诊断', '点击查同行']">查同行</el-button>
                <el-button type="primary" class="btn-create-report" @click="createReport()" v-bd-track-event="['营销力诊断', '点击一键生成报告']">一键生成报告</el-button>
            </div>
        </div>
        <el-progress
                v-show="true"
                :class="{'active': !isFinish}"
                :percentage="isFinish ? 0 : progressData.progress"
                :stroke-width="8"
                :show-text="false"
                status="success">
        </el-progress>

        <!--进度页面数据-->
        <detail-quantity :data="progressData"></detail-quantity>

    </div>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'
    import score from './Score.vue'
    import grade from './DetailGrade.vue'
    import detailQuantity from './DetailQuantity.vue'
    export default {
        components: {
            score,
            grade,
            detailQuantity
        },
        props: ['progressData', 'isFinish'],
        data () {
            return {
                showAlert: false,
                showAdvisory: true,
                time: 0
            }
        },
        computed: mapGetters('check', ['getTitle']),
        beforeUpdate () {
            if (!this.time) {
                this.time = new Date();
                return;
            }
            let endTime = (new Date() - this.time)/1000;
            if (endTime > 60) {
                this.showAlert = true;
            }
        },
        methods: {
            ...mapMutations('check', ['setFinish', 'setReportVisible', 'setPKVisible']),
            //取消检测
            cancelCheck () {
                this.$emit('cancelCheck');
            },
            //重新检测
            recheck () {
                this.setFinish(false);
                this.$emit('backIndex');
            },
            //生成报告
            createReport() {
                this.setReportVisible(true);
            },
            // 牛商网营销专家客服
            openCustomer () {
                let url = 'http://p.qiao.baidu.com/cps/chat?siteId=12162004&userId=1052055';
                window.open(url, '', 'width=800,height=600,left=200,top=100');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .detail-top {
        position: fixed;
        width: 100%;
        top: 70px;
        left: 0;
        z-index: 2;
        padding: 36px 0;
        background-color: #f4f2f3;
        border: 0;
    }
    .el-alert {
        position: absolute;
        top: -36px;
        left: 0;
        color: #777441;
        padding: 6px 16px;
        background-color: #fff9b7;
        transform: scaley(0);
        transition: all .5s ease;
        &.show {
            top: 0;
            transform: scaley(1);
        }
    }
    .detail-progress {
        $padding: 6rem;
        $height: 8rem;
        position: relative;
        padding: 0 $padding;
        .detail-p-1, .detail-p-2, .detail-p-3 {
            vertical-align: middle;
        }
        .detail-p-1 {
            position: absolute;
            top: 0;
            left: $padding;
            width: 130px;
            height: 130px;
        }
        .detail-p-2 {
            width: 88%;
            height: $height;
            padding: 0 17rem 0 $height+2.5rem;
        }
        .detail-p-3, .detail-p-4 {
            position: absolute;
            top: 0;
            margin-top: 1.8rem;
        }
        .detail-p-3 {
            right: 27%;
        }
        .detail-p-4 {
            right: $padding;
            .el-button {
                vertical-align: middle;
            }
        }
    }
    .title {
        font-size: 1.9rem;
        margin: 0 0 10px;
    }
    .subtitle {
        font-size: .9rem;
        color: #999;
        margin: 0 0 26px;
    }
    //取消诊断
    .button-cancel {
        width: 152px;
        height: 42px;
        font-size: 15px;
        color: #b0b0b4;
        border: 1px solid #b0b0b4;
        background-color: transparent;
    }
    .btn-recheck, .btn-create-report {
        height: 3.4rem;
        font-size: 1.2rem;
    }
    //返回
    .btn-back {
        font-size: 1rem;
        color: #a5a5a5;
    }
    //重新诊断
    .btn-recheck {
        width: 9rem;
        color: #a5a5a5;
        margin-left: 1.2rem;
        border: 1px solid #a5a5a5;
        background: none;
    }
    //一键生成报告
    .btn-create-report {
        width: 11rem;
        color: #fff;
        margin-left: 1.5rem;
    }
    .el-button--info.is-plain:focus, .el-button--info.is-plain:hover {
        border: 2px solid #333;
        color: #333;
    }
    .el-progress {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
    }
    .advisory {
        a {
            text-decoration: underline;
        }
    }
</style>
<style lang="scss">
    .detail .el-icon-close {
        color: #000;
    }
</style>



// WEBPACK FOOTER //
// app/view/detail/DetailProgress.vue